<template>
	<v-dialog v-model="choice.dialog" max-width="400px" persistent>
		<v-card>
			<v-card-title class="pt-6">
				<span class="headline">{{ choice.title }}</span>
			</v-card-title>
			<v-card-actions>
				<v-col cols="6">
					<v-btn block color="error" @click="sendChoice(false)"
						><v-icon left>fal fa-thumbs-down</v-icon> Não</v-btn
					>
				</v-col>
				<v-col cols="6">
					<v-btn block color="success" @click="sendChoice(true)"
						><v-icon left>fal fa-thumbs-up</v-icon> Sim</v-btn
					>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	inheritAttrs: false,

	props: {
		choice: {
			title: null,
			dialog: false,
		},
	},

	methods: {
		sendChoice(value) {
			this.choice.dialog = false
			this.$emit('choiceResult', value)
		},
	},
}
</script>
